module.exports = __webpack_public_path__ + "img/blue_018.a57c3c99.png";